import React from "react";

const Monitering = () => {
    return <div>Monitering</div>;
};

export default Monitering;
